import type { CampaignInstrument } from '../types'

/** Sum of reward budget allocated to published instruments on the campaign. */
export function computeLaunchBudgetUsed(
  instruments: CampaignInstrument[] | undefined,
): number {
  if (!instruments?.length) return 0
  return instruments.reduce((sum, row) => sum + (row.allocatedBudgetUsd ?? 0), 0)
}
